import { Channels } from '@/core/constants/channelConstants';
import { Roles } from '@/core/constants/roleConstants';
import { BasePolicy } from '../BasePolicy';

export class SchedulePolicy extends BasePolicy {
  static canList() {
    const roles = [
      Roles.SELLER,
      Roles.SUB_MANAGER,
      Roles.MANAGER,
      Roles.REGIONAL_MANAGER,
      Roles.SUB_DIRECTOR,
      Roles.DIRECTOR,
      Roles.EXPRESS_SALES,
      Roles.SUPER_USER,
      Roles.POST_SALE,
    ];

    const channels = [
      Channels.WHOLESALER,
      Channels.RETAIL,
      Channels.EXPORT,
      Channels.INDUSTRIAL,
      Channels.MODERN,
      Channels.PROJECT,
      Channels.ECOMMERCE,
    ];

    return this.hasAnyRole(roles) && this.hasAnyChannel(channels);
  }

  static canCreate() {
    const roles = [
      Roles.SELLER,
      Roles.SUB_MANAGER,
      Roles.MANAGER,
      Roles.REGIONAL_MANAGER,
      Roles.SUB_DIRECTOR,
      Roles.DIRECTOR,
      Roles.EXPRESS_SALES,
      Roles.SUPER_USER,
      Roles.POST_SALE,
    ];

    const channels = [
      Channels.WHOLESALER,
      Channels.RETAIL,
      Channels.EXPORT,
      Channels.INDUSTRIAL,
      Channels.MODERN,
      Channels.PROJECT,
      Channels.ECOMMERCE,
    ];

    return this.hasAnyRole(roles) && this.hasAnyChannel(channels);
  }

  static canUpdate() {
    const roles = [
      Roles.SELLER,
      Roles.SUB_MANAGER,
      Roles.MANAGER,
      Roles.REGIONAL_MANAGER,
      Roles.SUB_DIRECTOR,
      Roles.DIRECTOR,
      Roles.EXPRESS_SALES,
      Roles.SUPER_USER,
      Roles.POST_SALE,
    ];

    const channels = [
      Channels.WHOLESALER,
      Channels.RETAIL,
      Channels.EXPORT,
      Channels.INDUSTRIAL,
      Channels.MODERN,
      Channels.PROJECT,
      Channels.ECOMMERCE,
    ];

    return this.hasAnyRole(roles) && this.hasAnyChannel(channels);
  }
}
